import { Footer, Header, Page, PageTransition } from '@components/Page'
import { pickSeoProps } from '@components/Page/Page'
import { ProductOverview } from '@components/_product-overview/Overview'
import { SingleItemResponse } from '@lib/kontent'
import { ThemePage as ThemePageModel } from '@lib/kontent/models/ThemePage'
import { FC } from 'react'

type ThemePageProps = SingleItemResponse<ThemePageModel>

const ThemePage: FC<ThemePageProps> = (props) => {
  return (
    <Page {...pickSeoProps(props.item.elements)}>
      <Header initialVariant="absolute" />
      <PageTransition>
        <ProductOverview {...props} />
        <Footer />
      </PageTransition>
    </Page>
  )
}

export default ThemePage
